<template>
  <StyleColorSetPage
    :style-color-set="{
      ...browseSet,
      length: browseLength,
      styleColors: browseStyleColorsInfo,
      showAvailabilityToggle: true
    }"
    :style-colors-loading="!browseSectionLoaded || browseSectionLoadingPage"
    @bottom-of-set="debounceNextPage"
    @on-available-now-toggle="toggleAvailability()"
    @clear-all-filters="clearFilters"
    @remove-filter="removeFilter"
    @on-share-style-color-set-page="openShareModal(shareContext)"/>
</template>

<script>
import browseMixin from './browseMixin.vue'
import StyleColorSetPage from '@/components/styleColorSet/StyleColorSetPage.vue'

import { mapActions as mapVuexActions, mapState } from 'vuex'
import useAnalytics from '@shared/composables/analytics.js'
import { useModals } from '@/composables/modals.js'
import { useQueryStringFilters } from '@/composables/queryStringFilters.js'

export default {
  name: 'BrowsePage',
  components: {
    StyleColorSetPage
  },
  mixins: [browseMixin],
  setup () {
    const { openShareModal } = useModals()
    const { queryStringFilters, queryStringSort } = useQueryStringFilters()
    const { track } = useAnalytics()

    return {
      queryStringFilters,
      queryStringSort,
      openShareModal,
      track
    }
  },
  computed: {
    ...mapState('closet', [
      'browseStyleColors',
      'browseSectionLoaded',
      'browseSectionLoadingPage',
      'baseFilters',
      'browseSectionDetails'
    ]),
    browseStyleColorsInfo () {
      return this.browseStyleColors.data?.results
    },
    browseLength () {
      return this.browseStyleColors.data?.count
    },
    shareContext () {
      return { ...this.browseSet, styleColors: this.browseStyleColorsInfo }
    }
  },
  watch: {
    $route () {
      this.loadBrowseSection()
    }
  },
  created () {
    this.track('Viewed Browse Page')
  },
  async mounted () {
    await this.loadBrowseSection()
  },
  methods: {
    ...mapVuexActions('closet', [
      'getBrowseSectionsNextPage'
    ]),
    async loadBrowseSection () {
      const params = {
        section: this.$route.params.section,
        subsection: this.browseSubsectionParam,
        sectionId: this.sectionId,
        available: true,
        filters: this.queryStringFilters,
        sort: this.queryStringSort ?? this.sort
      }
      const details = this.browseSectionDetails
      const paramsMatch =
        details?.section === params.section &&
        details?.subsection === params.subsection &&
        details?.sectionId === params.sectionId &&
        details?.available === params.available &&
        JSON.stringify(details?.filters) === JSON.stringify(params.filters) &&
        details?.sort === params.sort

      if (!paramsMatch || !this.browseStyleColors?.data?.results?.length) {
        await this.getStyleColorsByBrowseSection({ ...params, filterOptions: true })
      }
    },
    removeFilter ({ filter }) {
      const filters = JSON.parse(JSON.stringify(this.browseSet.filters))
      filters[filter.filterType] = filters[filter.filterType].filter(value => value !== filter.value)
      this.applyFilters({ filters })
    },
    debounceNextPage () {
      clearTimeout(this.debounceNextBrowsePageTimeout)
      this.debounceNextBrowsePageTimeout = setTimeout(() => {
        this.getBrowseSectionsNextPage()
      }, 300)
    }
  }
}
</script>
